import { render } from "./Opcoes.vue?vue&type=template&id=7468b6b2"
import script from "./Opcoes.vue?vue&type=script&lang=js"
export * from "./Opcoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__